<template>
  <div id="app">
    <Snackbar />
    <transition name="fade" appear mode="out-in">
      <router-view/>
    </transition>
    <Modal :show="showPrivacyPolicy" @close="hidePrivacyPolicy">
      <h1>Privacy Policy</h1>
      <p>256c does not collect any user data, or tracks the user in any way. It doesn’t use cookies. It only stores the data the user inputted on the user’s device. This data can easily be exported from the Settings screen reachable from the Overview screen by swiping upwards after completing the initial setup.</p>
      <p>However, 256c is hosted on <a href="https://netlify.com" target="_blank">Netlify</a> in order to be publicly accessible. Netlify stores the IP addresses of site visitors for less than 30 days. For more information, please turn to their <a href="https://www.netlify.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://www.netlify.com/gdpr" target="_blank">GDPR Compliance Statement</a>.</p>
    </Modal>
    <Modal :show="showChangelog" @close="hideChangelog"><div v-html="changelog" /></Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Snackbar from '@/components/Snackbar.vue';

const changelog = require('../CHANGELOG.md');

export default {
  components: {
    Modal,
    Snackbar,
  },
  computed: {
    stateInitialized() {
      return this.$store.state.application.stateInitialized;
    },
  },
  data() {
    return {
      changelog,
      showChangelog: false,
      showPrivacyPolicy: false,
    };
  },
  methods: {
    hideChangelog() {
      const query = { ...this.$route.query };
      delete query.showChangelog;
      this.$router.replace({ query });
    },
    hidePrivacyPolicy() {
      const query = { ...this.$route.query };
      delete query.showPrivacyPolicy;
      this.$router.replace({ query });
    },
  },
  watch: {
    $route(to, from) {
      if (to.query.showChangelog && !this.showChangelog) this.showChangelog = true;
      if (!to.query.showChangelog && this.showChangelog) this.showChangelog = false;
      if (to.query.showPrivacyPolicy && !this.showPrivacyPolicy) this.showPrivacyPolicy = true;
      if (!to.query.showPrivacyPolicy && this.showPrivacyPolicy) this.showPrivacyPolicy = false;

      if (to.name === 'home' && from.name !== 'onboarding' && this.$store.state.application.installPrompt && !this.$store.state.user.prompted) {
        this.$store.commit('addToast', {
          message: 'You seem to be interested in using 256c, would you like to install it on your device? (You can always do so at a later point from the settings)',
          timeout: 10000,
          actionLabel: 'Install',
          action: () => {
            this.$store.state.application.installPrompt.prompt();
            this.$store.state.application.installPrompt.userChoice
              .then((choice) => {
                if (choice.outcome === 'accepted') this.$store.commit('addToast', { message: 'Great! Thank you for your trust.' });
                else this.$store.commit('addToast', { message: 'Should you change your mind, you can still install the application from the settings.' });
                this.$store.commit('setInstallPrompt', null);
              });
          },
        });
        this.$store.dispatch('setUserPrompted', true);
      }
    },
    stateInitialized(newVal) {
      if (newVal && this.$store.state.user.forceChangelog) {
        const query = { ...this.$route.query, showChangelog: true };
        this.$router.push({ query });
        this.$store.dispatch('setForceChangelog', false);
      }
    },
  },
};
</script>

<style lang="stylus">
@require 'styles/base'

#app
  height: 100%
  width: 100%
  max-width: 640px
  margin: 0 auto
  overflow: hidden

  .fade-enter-active,
  .fade-leave-active
    transition: opacity 200ms ease

    &.fade-enter,
    &.fade-leave-to
      opacity: 0
</style>
